<template>
  <!-- 节目库 -->
  <div class="section home-program">
    <home-title title="节目库" clickTitle @more="toSubList" @toList="toBaseList"></home-title>
    <div class="container">
      <!-- 分类 -->
      <JmkCate :curIndex="cateIndex" @mouseChange="mouseChange" @clickChange="toProgramList" />

      <div class="home-program-box" v-if="listAll">
        <loading v-show="showLoading" />
        <template v-if="listAll[cateId]">
          <template v-for="(item, index) in listAll[cateId]" v-if="index < 2">
            <program-full-item :item='item' :showpath="showpath" />
          </template>
          <div class="home-program-newsr program-lista">
            <template v-for="(item, index) in listAll[cateId]" v-if="index >= 2">
              <program-cate-item :showPic="true" :item='item' :showpath="showpath" />
            </template>
          </div>
          <div class="home-program-more" @click="toProgramList({ id: cateId })">+</div>

        </template>
      </div>
    </div>
  </div>
</template>

<script>
import colums from '../../colums/colums.js'
import JmkCate from '../jmk-cate.vue'
import programFullItem from '../listModel/programFullItem.vue'
import programItem from '../listModel/programItem.vue'
import programCateItem from '../listModel/program-cate-item.vue'
import loading from '../common/loading.vue'
import HomeTitle from './home-title.vue'
export default {
  name: 'Footer',
  props: {
    msg: String
  },
  components: {
    JmkCate, programFullItem, programItem, programCateItem, loading,
    HomeTitle
  },
  data() {
    return {
      cateList: colums.jmkcate,
      cateIndex: 0,
      cateId: colums.jmkcate[0].id,
      newsList: [],
      showpath: '',
      curNewsIndex: 0,
      listAll: {},
      showLoading: false
    }
  },
  mounted() {
    this.getjm(this.cateList[this.cateIndex].id);
  },
  methods: {
    // 节目库内容
    async getjm(cateid) {
      if (this.listAll && this.listAll[cateid]) {
        return;
      }
      this.showLoading = true;
      let params = {
        page: 1,
        pageSize: 6,
        type_id: cateid,
        recommend: 1
      }
      const res = await this.$api.jmkApi.getList(params)
      if (!this.showpath) this.showpath = res.showpath;
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_fill,w_654,h_436`),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.$set(this.listAll, cateid, list);
      this.showLoading = false;
    },


    //鼠标滑过 切换分类
    mouseChange(info) {
      // console.log(info);
      if (info) {
        this.cateIndex = info.index;
        this.cateId = info.id;
        // 重新加载节目库数据
        this.getjm(this.cateId);
      }
    },

    toProgramList({ id }) {
      if (id) {
        this.$router.push({
          path: '/program',
          query: {
            cate: id
          }
        })
      }
    },

    toBaseList() {
      this.$router.push('/program')
    },
    toSubList() {
      const path = this.cateList[this.cateIndex].path || '/program'
      this.$router.push(path)
    },
  },

}
</script>
<style scoped >
.home-program-pic {
  cursor: pointer;
}
</style>